import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import formatter from '../../../../common/helpers/formatter';
import type { Form } from '../../../../common/types/form';
import type { FbMeasure } from '../../../../common/types/client';
import TextExpander from '../../../../common/components/TextExpander';

type Props = {
  measure: FbMeasure;
  itemForm: Form<FbMeasure>;
};

function MeasureRow({ measure, itemForm }: Props) {
  const options = formatter.getFieldSelectOptions('type', itemForm.fields);
  const label = formatter.getOptionLabel(options, measure.type);

  return (
    <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start' minWidth='300px'>
      <Typography alignSelf='flex-start'>{formatter.formatGermanDate(measure.date)}</Typography>
      <TextExpander label={label} text={measure.notice} isHtml={true} />
    </Stack>
  );
}

export default MeasureRow;
